/**
 * SearchModal Theme
 *
 * @override
 * - Header has higher z-index than modal when search is open
 * - Modal content and overlay positioned below header
 * - blockScrollOnMount: true to lock body scroll when modal is open
 */

// Header heights for different breakpoints
const HEADER_HEIGHT = {
  base: '60px',
  lg: '80px',
};

export default {
  parts: [
    'modal',
    'overlay',
    'content',
    'closeButton',
    'body',
    'container'
  ],
  baseStyle: {
    modal: {
      // Block scroll on body when modal is open
      blockScrollOnMount: true,
    },
    overlay: {
      bg: 'brandColors.primaryBG',
      backdropFilter: 'blur(20px)',
      // Position overlay below header
      top: HEADER_HEIGHT,
      height: {base: `calc(100% - ${HEADER_HEIGHT.base})`, lg: `calc(100% - ${HEADER_HEIGHT.lg})`},
    },
    content: {
      size: 'full',
      bg: 'brandColors.primaryBG',
      backdropFilter: 'blur(20px)',
      position: 'relative',
      // Position content below header
      marginTop: HEADER_HEIGHT,
    },
    closeButton: {
      position: 'absolute',
      top: {base: 8, md: 8},
      right: {base: 8, md: 8},
      zIndex: 10,
      width: '20px',
      height: '20px',
      minWidth: '20px',
      minHeight: '20px',

      _hover: {opacity: 0.5},
    },
    body: {
      bg: 'transparent',
      paddingBottom: 6,
      px: {base: 5, md: 7.5},
      pt: 6,
      pb: {base: 10, md: 20},
    },
    container: {
      maxW: {base: 'full', md: '1060px'},
    },
  },
};
